import {
  LayoutDashboard,
  Tractor,
  Sprout,
  Wheat,
  Library,
  Users,
  Calculator,
  CloudSun,
  Lightbulb,
  Euro,
  Milk,
  Beef,
  Leaf,
  Wind,
  FlaskConical,
  FileText,
  Sparkles,
  PackageCheck,
  ShieldCheck,
  CreditCard,
  BriefcaseBusiness,
} from "lucide-react";

import AdminDashboard from "@/modules/AdminDashboard";
import Dashboard from "@/modules/Dashboard";
import FarmManagement from "@/modules/FarmManagement";
import Paddocks from "@/modules/Paddocks";
import FeedInventory from "@/modules/FeedInventory";
import FeedBudget from "@/modules/FeedBudget";
import AnimalGroups from "@/modules/AnimalGroups";
import NutritionEvaluation from "@/modules/NutritionEvaluation";
import NutritionAdvisor from "@/modules/NutritionAdvisor";
import Weather from "@/modules/Weather";
import Recommendations from "@/modules/Recommendations";
import GrassQuality from "@/modules/GrassQuality";
import Billing from "@/modules/Billing";
import ConsultantDashboard from "@/modules/ConsultantDashboard";

export const modules = [
  {
    key: "dashboard",
    title: "Dashboard",
    path: "/app",
    icon: LayoutDashboard,
    component: Dashboard,
    group: "Overview",
  },
  {
    key: "farm",
    title: "Farm Management",
    path: "/app/farm",
    icon: Tractor,
    component: FarmManagement,
    group: "Overview",
  },
  {
    key: "paddocks",
    title: "Paddock & Grass",
    path: "/app/paddocks",
    icon: Sprout,
    component: Paddocks,
    group: "Grassland",
  },
  {
    key: "grass-quality",
    title: "Grass Quality",
    path: "/app/grass-quality",
    icon: FlaskConical,
    component: GrassQuality,
    group: "Grassland",
  },
  {
    key: "weather",
    title: "Weather",
    path: "/app/weather",
    icon: CloudSun,
    component: Weather,
    group: "Grassland",
  },
  {
    key: "feeds",
    title: "Feed Inventory",
    path: "/app/feeds",
    icon: Wheat,
    component: FeedInventory,
    group: "Nutrition",
  },
  {
    key: "feed-budget",
    title: "Feed Budget",
    path: "/app/feed-budget",
    icon: PackageCheck,
    component: FeedBudget,
    group: "Nutrition",
  },
  {
    key: "nutrition-evaluation",
    title: "Rations & Nutrition",
    path: "/app/nutrition-evaluation",
    icon: Calculator,
    component: NutritionEvaluation,
    group: "Nutrition",
  },
  {
    key: "advisor",
    title: "AI Nutrition Advisor",
    path: "/app/advisor",
    icon: Sparkles,
    component: NutritionAdvisor,
    group: "Nutrition",
  },
  {
    key: "animals",
    title: "Animal Groups",
    path: "/app/animals",
    icon: Users,
    component: AnimalGroups,
    group: "Herd",
  },
  {
    key: "recommendations",
    title: "Recommendations",
    path: "/app/recommendations",
    icon: Lightbulb,
    component: Recommendations,
    group: "Overview",
  },
  {
  key: "consultant",
  title: "Consultant Dashboard",
  path: "/app/consultant",
  icon: BriefcaseBusiness,
  component: ConsultantDashboard,
  group: "Consultant",
  consultantOnly: true,
},
  {
  key: "billing",
  title: "Subscription & Billing",
  path: "/app/billing",
  icon: CreditCard,
  component: Billing,
  group: "Account",
},
  {
    key: "admin",
    title: "Admin",
    path: "/app/admin",
    icon: ShieldCheck,
    component: AdminDashboard,
    group: "Administration",
    adminOnly: true,
  },
];

export const futureModules = [
  {
    key: "financial",
    title: "Financial Analysis",
    icon: Euro,
    group: "Business",
  },
  {
    key: "milk",
    title: "Milk Recording",
    icon: Milk,
    group: "Herd",
  },
  {
    key: "beef",
    title: "Beef Growth Tracking",
    icon: Beef,
    group: "Herd",
  },
  {
    key: "carbon",
    title: "Carbon Footprint",
    icon: Leaf,
    group: "Sustainability",
  },
  {
    key: "methane",
    title: "Methane Prediction",
    icon: Wind,
    group: "Sustainability",
  },
  {
    key: "fertiliser",
    title: "Fertiliser Planning",
    icon: Sprout,
    group: "Grassland",
  },
  {
    key: "soil",
    title: "Soil Analysis",
    icon: FlaskConical,
    group: "Grassland",
  },
  {
    key: "reports",
    title: "Report Generator",
    icon: FileText,
    group: "Business",
  },
];

export const SparklesIcon = Sparkles;
